import { EventAttributeFormVM } from './event-attribute-form.viewmodel';
import { withViewModel } from '../../../../../infrastructure/components/with-view-model';
import { EventAttributeFormPresentation } from './event-attribute-form.presentation';


export type EventAttributeFormProps = {
    accountId: number;
    attributeId?: string;
    apiCallSuccessCallback: () => void;
    deleteCallback?: () => void;
};

export const EventAttributeForm = withViewModel(EventAttributeFormPresentation, async (props: EventAttributeFormProps) => {
    const vm = new EventAttributeFormVM(
        props.accountId,
        props.apiCallSuccessCallback,
        props.deleteCallback,
        props.attributeId
    );

    return vm;
});
